import { render, staticRenderFns } from "./ArrearsFilter.vue?vue&type=template&id=148b8f67"
import script from "./ArrearsFilter.vue?vue&type=script&lang=js"
export * from "./ArrearsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports